import { RouteObject } from "react-router-dom"
import AuthGuard from "../../../shared/auth/component/auth"
import NewParkingLotComponent from "../component/new-parking-lot-component"
import ParkingPage from "../page/parking.page"
export const ParkingLotRoute: RouteObject = {
  path: "/parking-lot",
  element: (
    <AuthGuard role={["super_admin", "owner"]} permission={["manage-parking", "view-parking"]}>
      <ParkingPage />
    </AuthGuard>
  ),
  children: [
    {
      path: "detail/:type/:id",
      element: <NewParkingLotComponent editMode="detail" />,
    },
    { path: ":id", element: <NewParkingLotComponent editMode="new" /> },
  ],
}
